;(() => {
	const initSlider = (section) => {
		let testCertificationSlider, navigation, pagination

		if (document.currentScript) {
			testCertificationSlider = document.currentScript.parentElement.querySelector(
				'.test-certification__slider'
			)
			if (testCertificationSlider) {
				navigation = document.currentScript.parentElement.querySelector(
					'.test-certification__navigation'
				)
				pagination = document.currentScript.parentElement.querySelector(
					'.test-certification__pagination'
				)
			}
		} else {
			testCertificationSlider = section.querySelector('.test-certification__slider')
			if (testCertificationSlider) {
				navigation = section.querySelector('.test-certification__navigation')
				pagination = section.querySelector('.test-certification__pagination')
			}
		}

		if (testCertificationSlider) {
			const columns = Number(testCertificationSlider.dataset.columns)
			let columns750
			if (columns > 1) columns750 = columns - 1
			else columns750 = columns

			let swiperParams = {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 24,
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {
					750: {
						slidesPerView: columns750,
						slidesPerGroup: columns750,
					},
					1200: {
						slidesPerView: columns,
						slidesPerGroup: columns,
					},
				},
			}

			if (testCertificationSlider.getAttribute('data-pagination') === 'true') {
				swiperParams.pagination = {
					el: pagination,
					type: 'bullets',
					clickable: true,
				}
			}

			if (testCertificationSlider.getAttribute('data-navigation') === 'true') {
				swiperParams.navigation = {
					nextEl: navigation.querySelector('.swiper-button-next'),
					prevEl: navigation.querySelector('.swiper-button-prev'),
				}
			}

			const testCertificationSwiper = new Swiper(testCertificationSlider, swiperParams)
		}
	}

	initSlider()

	document.addEventListener('shopify:section:load', function (section) {
		initSlider(section.target)
	})
})()
